import request from '@/utils/request'

// 获取停车场列表
export function listParkingSpaces(query) {
  return request({
    url: '/parking/space/list',
    method: 'get',
    params: query
  })
}

// 获取停车场列表
export function selectSpaceListParent(query) {
  return request({
    url: '/parking/space/selectSpaceListParent',
    method: 'get',
    params: query
  })
}

// 获取停车场详情
export function getParkingSpace(id) {
  return request({
    url: '/parking/space/' + id,
    method: 'get'
  })
}

// 获取停车场信息 (移动端，无数据权限限制)
export function getParkingSpaceInfo(id) {
  return request({
    url: '/parking/space/infoMobile/' + id,
    method: 'get'
  })
}

// 获取附近停车场（使用 nearby-availability 接口，支持 level、includeImages）
export function getNearbyParkingSpaces({ lat, lng, radius, includeImages, level }) {
  return request({
    url: '/parking/space/nearby-availability',
    method: 'get',
    params: {
      lat,
      lng,
      radius,
      includeImages,
      level: level ?? 1  // 默认 level=1（一级车场）
    }
  })
}

// Get availability information for a parking space
export function getParkingSpaceAvailability(parkingSpaceId) {
  return request({
    url: '/parking/space/availability',
    method: 'get',
    params: {
      parkingSpaceId
    }
  })
}

// Add this new function
export function listPaginatedParkingSpaces(params) {
  return request({
    url: '/parking/space/list-paginated',
    method: 'get',
    params
  })
}

// Get nearby parking spaces with availability
export function getNearbyParkingSpacesWithAvailability(params) {
  return request({
    url: '/parking/space/nearby-availability',
    method: 'get',
    params
  })
}

export function selectParkingSpaceByPosition(params) {
  return request({
    url: '/parking/space/selectParkingSpaceByPosition',
    method: 'post',
    data:params
  })
}

// 根据城市代码获取停车场列表
export function getParkingSpacesByCityCode(cityCode) {
  return request({
    url: '/parking/space/byCityCode/' + cityCode,
    method: 'get'
  })
}
